<template>
  <div v-show="layers.length" class="mapToolbox" id="mapLegendToggler">
    <MapButton
      label="Toggle legend"
      icon="/icons/toolbox/legend.svg"
      :active="active || toggled"
      size="small"
      @action="toggleLegend"
     :map-controller="mapController"/>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import MapButton from "../MapButton.vue";
import { MapController } from "../../../js/Map/map-controller";
import MapLegendDialog from "../MapLegendDialog.vue";
import { MapEvent } from "../../../js/document/model/map";

export default defineComponent({
  name: "MapLegendToggleControl",
  components: { MapButton },
  props: {
    mapController: {
      type: Object as PropType<MapController>,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      toggled: false,
      dialog: undefined,
      layers: [],
    };
  },
  mounted() {
    this.layers = this.mapController?.getLayers()?.filter((el) => el?.properties?.legend?.length);
    this.mapController.mapInstance.on(MapEvent.LayersChange, () => {
      this.layers = this.mapController.getLayers().filter((el) => el?.properties?.legend?.length);
    });
    if (!this.active) {
      return;
    }
    setTimeout(() => this.toggleLegend());
  },
  methods: {
    toggleLegend() {
      if (this.toggled) {
        this.dialog?.close();
      } else if (this.mapController.getLayers().length) {
        this.dialog = this.mapController.configuration.dialogProvider().open(MapLegendDialog, {
          props: {
            modal: false,
            header: this.$t("Legend"),
            position: "topright",
            appendTo: "#mapWrapper",
            style: {
              position: "relative",
              top: "80px",
              right: "40px",
              width: "300px",
              "min-width": "300px",
              height: "500px",
              "min-height": "500px",
              resize: "both",
              overflow: "hidden",
            },
          },
          data: {
            mapController: this.mapController,
          },
          onClose: (options) => {
            this.toggled = false;
            this.dialog = undefined;
          },
        });
      }

      this.toggled = !this.toggled;
    },
  },
});
</script>

<style lang="scss"></style>
